/**
 * Session expiry — thin re-export of @busmgr/session-expiry for this app.
 */

import { createSessionExpiry, SESSION_REASON as PACKAGE_SESSION_REASON } from '@busmgr/session-expiry';

const session = createSessionExpiry({
  storageKeys: ['admin_token'],
  loginPath: '/admin',
});

export const SESSION_REASON = PACKAGE_SESSION_REASON;
export const {
  forceSessionExpired,
  consumeSessionNotice,
  shouldBlockSilentSso,
  reasonFromAuthError,
  isSessionRedirectInProgress,
  isAuthFailure,
  clearLocalSession,
  attachVisibilityHeartbeat,
} = session;

export default session;
